(function () {
  class SlBestSellers extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.tabButtons = Array.from(this.querySelectorAll('[data-sl-best-tab]'));
      this.panes = Array.from(this.querySelectorAll('[data-sl-best-pane]'));
      this.boundUpdateProgress = this.updateAllProgress.bind(this);
      this.swipers = [];

      this.tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.activatePane(button.dataset.slBestTab);
        });
      });

      window.addEventListener('resize', this.boundUpdateProgress);
      this.activatePane(this.tabButtons[0]?.dataset.slBestTab);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundUpdateProgress);
      this.swipers.forEach((swiper) => swiper?.destroy?.(true, true));
    }

    activatePane(id) {
      if (!id) return;

      this.tabButtons.forEach((button) => {
        const isActive = button.dataset.slBestTab === id;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panes.forEach((pane) => {
        const isActive = pane.dataset.slBestPane === id;
        pane.classList.toggle('is-active', isActive);
        pane.hidden = !isActive;

        if (isActive) {
          this.ensureSwiper(pane);
        }
      });
    }

    ensureSwiper(pane) {
      const slider = pane?.querySelector('[data-sl-best-slider]');
      const nextButton = pane?.querySelector('[data-sl-best-next]');
      const prevButton = pane?.querySelector('[data-sl-best-prev]');
      if (!slider || typeof window.Swiper === 'undefined') return;

      const existingSwiper = slider.swiper;
      if (existingSwiper) {
        window.requestAnimationFrame(() => {
          existingSwiper.update();
          existingSwiper.slideTo(0, 0);
          this.updateProgress(pane);
        });
        return;
      }

      const swiper = new window.Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 600,
        watchOverflow: true,
        navigation:
          nextButton && prevButton
            ? {
                nextEl: nextButton,
                prevEl: prevButton,
              }
            : false,
        breakpoints: {
          1025: {
            slidesPerView: 'auto',
            spaceBetween: 18,
          },
        },
        on: {
          init: () => this.updateProgress(pane),
          resize: () => this.updateProgress(pane),
          setTranslate: () => this.updateProgress(pane),
          transitionEnd: () => this.updateProgress(pane),
        },
      });

      this.swipers.push(swiper);
    }

    updateAllProgress() {
      this.panes.forEach((pane) => {
        if (pane.hidden) return;
        this.updateProgress(pane);
      });
    }

    updateProgress(pane) {
      const slider = pane?.querySelector('[data-sl-best-slider]');
      const track = pane?.querySelector('.sl-best-sellers__progress');
      const fill = pane?.querySelector('[data-sl-best-progress-fill]');
      if (!fill || !track) return;

      const swiper = slider?.swiper;
      if (!swiper) return;

      const snapCount = swiper.snapGrid?.length || 0;
      if (snapCount <= 1) {
        fill.style.width = '100%';
        fill.style.transform = 'translateX(0px)';
        return;
      }

      const visibleRatio = Math.min(1, swiper.width / swiper.virtualSize);
      const trackWidth = track.clientWidth || 100;
      const thumbWidthPx = Math.max(24, visibleRatio * trackWidth);
      const minTranslate = swiper.minTranslate ? swiper.minTranslate() : 0;
      const maxTranslate = swiper.maxTranslate ? swiper.maxTranslate() : 0;
      const translateRange = minTranslate - maxTranslate;
      let progress = 0;

      if (translateRange > 0) {
        progress = (minTranslate - swiper.translate) / translateRange;
      }

      progress = Math.min(1, Math.max(0, progress));
      const travelPx = Math.max(0, trackWidth - thumbWidthPx);

      fill.style.width = `${thumbWidthPx}px`;
      fill.style.transform = `translateX(${travelPx * progress}px)`;
    }
  }

  if (!customElements.get('sl-best-sellers')) {
    customElements.define('sl-best-sellers', SlBestSellers);
  }
})();
